import React from 'react'
import { useGetBooksQuery } from '../features/api/apiSlice'
import BookItem from './BookItem'

export default function BookList({ searchQuery, isFeaturedSelected }) {
    const { data, isLoading, isError, error, isSuccess } = useGetBooksQuery();

    let content = null;
    if (data?.length > 0) {
        let books = data;
        console.log('books (before filtering):', books);
        if (searchQuery && !isLoading && isSuccess) {
            books = data.filter((book) => book.name.toLowerCase().includes(searchQuery.trim().toLowerCase()));

            console.log(searchQuery);
            console.log(books);
        }
        if (isFeaturedSelected) {
            books = data.filter((book) => book.featured);
        }
        console.log('books (after filtering):', books);
        content = books.map((el) => <BookItem key={el.id} book={el} />);
    }

    return (
        <div class="space-y-6 md:space-y-0 md:grid grid-cols-1 lg:grid-cols-3 gap-6">
            {content}
        </div>
    )
}
